import React from "react";
import Home from "./views/Home";
import About from "./views/About";
import Contact from "./views/ContactUs";
import Doctor from "./views/doctors/Doctor";
import FavouriteDoctors from "./views/doctors/FavouriteDoctors";
import Offer from "./views/offers/Offer";
import OfferDetails from "./views/offers/OfferDetails";
import Blog from "./views/blog/Blog";
import BlogCategoryPosts from "./views/blog/BlogCategoryPosts";
import BlogTagPosts from "./views/blog/BlogTagPosts";
import SingleBlog from "./views/blog/SingleBlog";
import Profile from "./views/user/Profile";
import UserHistory from "./views/user/UserHistory";
import PaymentTerms from "./views/terms/PaymentTerms";
import Terms from "./views/terms/Terms";
import Privacy from "./views/terms/Privacy";
import Refund from "./views/terms/Refund";
import Download from "./views/downloadApp/Download";
import DownloadForDoctors from "./views/downloadApp/DownloadForDoctors";
import DoctorAndHospitalProfile from "./views/doctors/DoctorAndHospitalProfile";
import PremiumBenefits from "./views/premium/PremiumBenefits";
import CashBack from "./views/premium/CashBack";
import Login from "./views/auth/Login";
import Register from "./views/auth/Register";
import Activate from "./views/auth/Activate";
import ForgetPassword from "./views/auth/ForgetPassword";
import ResetPassword from "./views/auth/ResetPassword";
import NoMatch from "./views/NoMatch";
import {Route, Switch} from "react-router-dom";
import Master from "./views/layouts/Master";
import Auth from "./views/layouts/Auth";
import {withTranslate} from "react-redux-multilingual";


/*
const fakeAuth = {
    isAuthenticated: false,
    login(cb){
        this.isAuthenticated = true
    },
    logout(cb){
        this.isAuthenticated = false
    },
}*/



const DefaultRoute = ({component: Component, ...rest}) => (
    <Route {...rest} render={(props) => (
        <Master language={rest.language} mobileMenuIsShown={rest.mobileMenuIsShown}>
            <Component language={rest.language} mobileMenuIsShown={rest.mobileMenuIsShown}
                       title={rest.title}  {...props} />
        </Master>
    )}/>
);


const AuthRoute = ({component: Component, ...rest}) => (
    <Route {...rest} render={(props) => (
        <Auth language={rest.language} mobileMenuIsShown={rest.mobileMenuIsShown}>
            <Component language={rest.language} mobileMenuIsShown={rest.mobileMenuIsShown}
                       title={rest.title}  {...props} />
        </Auth>
    )}/>
);


const PrivateRoute = ({component: Component, ...rest}) => (
    <Route {...rest} render={(props) => (
        <div>
            <Component language={rest.language} mobileMenuIsShown={rest.mobileMenuIsShown}
                       title={rest.title}  {...props} />
        </div>
    )}/>
);


class Routes extends React.Component {
    state = {
        mobileMenuIsShown: false,
        language: 'en',
    };

    render() {
        return (
            <Switch>
                <DefaultRoute language={this.state.language}
                              mobileMenuIsShown={this.state.mobileMenuIsShown} exact path="/"
                              title={this.props.translate("home_title")} component={Home}/>
                <DefaultRoute language={this.state.language}
                              mobileMenuIsShown={this.state.mobileMenuIsShown} path="/about"
                              title={this.props.translate("about_title")} component={About}/>
                <DefaultRoute language={this.state.language}
                              mobileMenuIsShown={this.state.mobileMenuIsShown} path="/contact"
                              title={this.props.translate("contact_title")} component={Contact}/>
                <DefaultRoute language={this.state.language} exact
                              mobileMenuIsShown={this.state.mobileMenuIsShown} path="/doctors"
                              title={this.props.translate("doctors_title")}
                              component={Doctor}/>
                <DefaultRoute language={this.state.language} exact
                              mobileMenuIsShown={this.state.mobileMenuIsShown}
                              path="/doctors/favourite"
                              title={this.props.translate("doctors_favourite_title")}
                              component={FavouriteDoctors}/>
                <DefaultRoute language={this.state.language}
                              mobileMenuIsShown={this.state.mobileMenuIsShown} path="/offers"
                              title={this.props.translate("offers_title")}
                              component={Offer}/>
                <DefaultRoute language={this.state.language}
                              mobileMenuIsShown={this.state.mobileMenuIsShown} path="/offer/:id"
                              title={this.props.translate("offer_details_title")}
                              component={OfferDetails}/>
                {/*  <DefaultRoute language={this.state.language} mobileMenuIsShown={this.state.mobileMenuIsShown} path="/contact"
                                          title={this.props.translate("contact_title")}
                                          component={Contact}/>*/}
                <DefaultRoute language={this.state.language}
                              mobileMenuIsShown={this.state.mobileMenuIsShown} exact path="/blog"
                              title={this.props.translate("blog_title")}
                              component={Blog}/>
                <DefaultRoute language={this.state.language}
                              mobileMenuIsShown={this.state.mobileMenuIsShown} exact
                              path="/blog/category/:category"
                              title={this.props.translate("blog_category_title")}
                              component={BlogCategoryPosts}/>
                <DefaultRoute language={this.state.language}
                              mobileMenuIsShown={this.state.mobileMenuIsShown} exact path="/blog/tag/:tag"
                              title={this.props.translate("blog_tag_title")}
                              component={BlogTagPosts}/>
                <DefaultRoute language={this.state.language}
                              mobileMenuIsShown={this.state.mobileMenuIsShown} exact
                              path="/blog/post/:post_name"
                              title={this.props.translate("blog_post_title")}
                              component={SingleBlog}/>
                <DefaultRoute language={this.state.language}
                              mobileMenuIsShown={this.state.mobileMenuIsShown} exact path="/profile"
                              title={this.props.translate("profile_title")}
                              component={Profile}/>
                <DefaultRoute language={this.state.language}
                              mobileMenuIsShown={this.state.mobileMenuIsShown} path="/my-appointments/:status?"
                              title={this.props.translate("my_appointments_title")}
                              component={UserHistory}/>
                <DefaultRoute language={this.state.language}
                              mobileMenuIsShown={this.state.mobileMenuIsShown} path="/payment"
                              title={this.props.translate("payment_terms_title")} component={PaymentTerms}/>
                <DefaultRoute language={this.state.language}
                              mobileMenuIsShown={this.state.mobileMenuIsShown} path="/terms"
                              title={this.props.translate("terms_title")} component={Terms}/>
                <DefaultRoute language={this.state.language}
                              mobileMenuIsShown={this.state.mobileMenuIsShown} path="/privacy"
                              title={this.props.translate("privacy_title")}
                              component={Privacy}/>
                <DefaultRoute language={this.state.language}
                              mobileMenuIsShown={this.state.mobileMenuIsShown} path="/refund/:reservation_id"
                              title={this.props.translate("refund_title")} component={Refund}/>
                <DefaultRoute language={this.state.language} exact
                              mobileMenuIsShown={this.state.mobileMenuIsShown} path="/download"
                              title={this.props.translate("download_title")}
                              component={Download}/>
                <DefaultRoute language={this.state.language} exact
                              mobileMenuIsShown={this.state.mobileMenuIsShown} path="/doctor/download"
                              title={this.props.translate("join_our_doctors_title")}
                              component={DownloadForDoctors}/>
                {/*         <DefaultRoute language={this.state.language} mobileMenuIsShown={this.state.mobileMenuIsShown} path="/specialty/:slug"
                                          title="" component={SingleSpecialty}/>*/}
                <DefaultRoute language={this.state.language}
                              exact
                              mobileMenuIsShown={this.state.mobileMenuIsShown}
                              path="/doctor/:id/:is_hospital?"
                    // title={this.props.translate("single_doctor_title")}
                              component={DoctorAndHospitalProfile}/>
                <DefaultRoute language={this.state.language}
                              mobileMenuIsShown={this.state.mobileMenuIsShown} path="/premium"
                              title={this.props.translate("premium_title")}
                              component={PremiumBenefits}/>
                <DefaultRoute language={this.state.language}
                              mobileMenuIsShown={this.state.mobileMenuIsShown} path="/cash-back"
                              title={this.props.translate("cash_back_title")}
                              component={CashBack}/>

                <AuthRoute language={this.state.language} mobileMenuIsShown={this.state.mobileMenuIsShown}
                           path="/login"
                           title={this.props.translate("login_title")}
                           component={Login}/>
                <AuthRoute language={this.state.language} mobileMenuIsShown={this.state.mobileMenuIsShown}
                           path="/register"
                           title={this.props.translate("register_title")}
                           component={Register}/>
                <AuthRoute language={this.state.language} mobileMenuIsShown={this.state.mobileMenuIsShown}
                           path="/user/:id"
                           title={this.props.translate("register_title")}
                           component={Register}/>
                <AuthRoute language={this.state.language} mobileMenuIsShown={this.state.mobileMenuIsShown}
                           path="/activate"
                           title={this.props.translate("activate_title")}
                           component={Activate}/>
                <AuthRoute language={this.state.language} mobileMenuIsShown={this.state.mobileMenuIsShown}
                           path="/forget-password"
                           title={this.props.translate("forget_password_title")}
                           component={ForgetPassword}/>
                <AuthRoute language={this.state.language} mobileMenuIsShown={this.state.mobileMenuIsShown}
                           path="/reset-password"
                           title={this.props.translate("reset_password_title")}
                           component={ResetPassword}/>
                <PrivateRoute title={this.props.translate("no_match_title")} language={this.state.language}
                              mobileMenuIsShown={this.state.mobileMenuIsShown} component={NoMatch}/>
            </Switch>
        );
    }
}

export default  withTranslate(Routes);